import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useLanguageDetector = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Check if there's a stored language preference
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }

    // Set up listener for language changes to store preference
    const handleLanguageChanged = (lng: string) => {
      localStorage.setItem('language', lng);
    };

    i18n.on('languageChanged', handleLanguageChanged);

    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  return { currentLanguage: i18n.language, changeLanguage: i18n.changeLanguage };
};
